module.exports = __webpack_public_path__ + "img/i_plus_dark_g.f53f7b5b.svg";